const sl_SI = {
    homepage_title: 'Prenesi CalendarTask mobilno različico s QR kodo',
    homepage_slogn: 'CalendarTask mobilna različica',
    homepage_ios_download: 'App Store v pregledu...',
    homepage_download: 'Prenesi',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'Prenesi CalendarTask mobilno različico s QR kodo',
    phonedownload_slogan: 'Sinhronizacija s PC in tabličnim računalnikom, beleženje povsod',
    phonedownload_send_vip: 'Namestite aplikacijo in prejmite VIP članstvo',
    phonedownload_screenshot: 'Posnetek zaslona',
    phodedownload_macos: 'CalendarTask različica macOS',
    phodedownload_windows: 'CalendarTask različica Windows',
    phodedownload_otherbutton: 'Poglej zdaj',
    phodedownload_about: 'Kontakt',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Brez oglasov',
    feature_easy: 'Mesečni pogled, preprost in enostaven',
    feature_reminder: 'Prilagojeno opozorilo',
    feature_countdown: 'Odbrojavanje obletnice',

    vip_task_succ: 'Uspeh. Prenesite aplikacijo za aktivacijo VIP',
    vip_task_error: 'Prejem ni uspel',

    group_slogn: 'Povabilo CalendarTask ekipa',

    tt_title: 'CalendarTask',
    tt_share_1: 'Deljeno z vami',
    tt_share_2: 'Urnik',
    tt_share_show_1: 'Skenirajte QR kodo z aplikacijo "CalendarTask", PC in mobilnik bosta prikazala',
    tt_share_show_2: 'urnik',
    tt_share_scan_1: 'Skeniraj z',
    tt_share_scan_2: 'aplikacijo "CalendarTask"',
    tt_share_succ: 'Sinhronizacija uspešna',

    v2_copyright: 'Kontakt service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Vse pravice pridržane.',
    v2_download_appstore: 'Prenesi v App Store',
    v2_download_googleplay: 'Na voljo v Google Play',

    v2_main_title: 'CalendarTask Mobilni',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Mobilni',
    v2_main_description: 'Poiščite <span class="name">CalendarTask</span> v App Store ali Google Play',
    v2_download_ios: 'Prenesi iOS',
    v2_download_android: 'Prenesi Android',
    v2_download_harmonyos: 'Prenesi HarmonyOS',
    v2_sync_status: 'Sinhronizacija končana! 1 naloženo, 0 preneseno',
    v2_feature_title: 'Sinhronizacija podatkov več naprav',
    v2_feature_description: 'Sinhronizacija med mobilnikom, tabličnim računalnikom in PC'
};
export default sl_SI;
